import { socialLinks } from "@/config/social";

/**
 * Persistent social rail pinned to the right edge of the landing pages.
 *
 * Desktop only. On phones and tablet portrait it would sit on top of the
 * content, and the footer icons plus the mobile menu already cover that case.
 *
 * Sits at z-40 so the navbar (z-50) and the Back-to-top button (z-50, pinned
 * bottom-right) both stay above it; vertically centred, so the two never meet.
 */
export default function SocialRail() {
  if (socialLinks.length === 0) return null;

  return (
    <nav
      aria-label="Follow Yoluno"
      className="hidden lg:flex fixed right-4 top-1/2 -translate-y-1/2 z-40 flex-col gap-2.5"
    >
      {socialLinks.map(({ label, href, Icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Yoluno on ${label}`}
          title={label}
          className="grid place-items-center w-11 h-11 rounded-full bg-card/90 backdrop-blur-sm border border-border text-muted-foreground shadow-warm-sm hover:text-primary hover:border-primary hover:-translate-x-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-all duration-200 motion-reduce:transition-none motion-reduce:hover:translate-x-0"
        >
          <Icon className="w-5 h-5" />
        </a>
      ))}
    </nav>
  );
}
